import React from 'react';
import { useOffices } from 'redux/models/offices/hooks';
import { Page } from 'theme/components/Layout/Layout';
import OfficePageContent from './OfficePageContent/OfficePageContent';
import Message from 'theme/components/Message';
import Loader from 'theme/components/Loader/Loader';
import { ParamsContext } from 'components/Context/ParamsContext';
import { PARAM_LOADED_CALLBACK } from 'config/params';
import Styles from './OfficePage.scss';

const ErrorMessage = () => (
  <Message>
    Извините, произошла ошибка. Попробуйте перезагрузить страницу
  </Message>
);

const OfficePage = () => {
  const {
    [PARAM_LOADED_CALLBACK]: onContentLoaded,
  } = React.useContext(ParamsContext);

  const { offices, isError, isLoading, isLoaded } = useOffices();

  const onContentLoadedInvoked = React.useRef(false);
  React.useEffect(() => {
    if (isLoaded && !onContentLoadedInvoked.current) {
      onContentLoaded();
      onContentLoadedInvoked.current = true;
    }
  }, [isLoaded, onContentLoaded]);

  switch (true) {
    case isLoading:
      return (
        <div className={Styles.pageLoader}>
          <Loader />
        </div>
      );
    case isLoaded:
      return (
        <Page>
          <OfficePageContent offices={offices} />
        </Page>
      );
    case isError:
      return <ErrorMessage />;
    default:
      return null;
  }
};

export default OfficePage;
